const NUMBER_OF_IMAGE_LIMIT = 20;
const NUMBER_OF_REVIEW_IMAGE_LIMIT = 4;
const GIG_PAGINATION_LIMIT = 6;
const CHEF_PAGINATION_LIMIT = 4;
const NEARBY_CHEF_DISTANCE_LIMIT = 50;
const NEARBY_GIG_DISTANCE_LIMIT = 500;
const NUMBER_OF_NEARBY_CHEF_LIMIT = 6;
const NUMBER_OF_NEARBY_GIG_LIMIT = 6;
const POTENTIAL_FALSE_POSITIVES = 2;

export {
  CHEF_PAGINATION_LIMIT,
  GIG_PAGINATION_LIMIT,
  NEARBY_CHEF_DISTANCE_LIMIT,
  NEARBY_GIG_DISTANCE_LIMIT,
  NUMBER_OF_IMAGE_LIMIT,
  NUMBER_OF_NEARBY_CHEF_LIMIT,
  NUMBER_OF_NEARBY_GIG_LIMIT,
  NUMBER_OF_REVIEW_IMAGE_LIMIT,
  POTENTIAL_FALSE_POSITIVES,
};
